module.exports = __webpack_public_path__ + "img/pampa.78b37497.png";